/**
 * SoundChannelType.ts
 */
export class SoundChannelType {
}
SoundChannelType.MUSIC = "SoundChannelType.MUSIC";
SoundChannelType.EFFECTS = "SoundChannelType.EFFECTS";
SoundChannelType.AMBIENT = "SoundChannelType.AMBIENT";
//# sourceMappingURL=SoundChannelType.js.map